import React from 'react'
import styles from './LbAnalytics.module.css'
import { motion } from 'framer-motion'
import { FaChartLine, FaBullseye, FaUserClock } from 'react-icons/fa'

const analyticsPoints = [
    {
        icon: <FaChartLine />,
        title: 'Track Every Submission',
        description: 'Real-time insights into how many leads you’re getting from each form and page.'
    },
    {
        icon: <FaBullseye />,
        title: 'Conversion Heatmap',
        description: 'Know which page, button or timing is driving the most appointments or inquiries.'
    },
    {
        icon: <FaUserClock />,
        title: 'Engagement Timing',
        description: 'Understand when users are most active, and plan your campaigns for max effectiveness.'
    }
]

const LbAnalytics = () => {
    return (
        <section className={styles.analyticsSection}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    Analytics That Empower
                </motion.h2>

                <motion.p
                    className={styles.subheading}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    See exactly how your lead forms are performing and make smarter marketing decisions.
                </motion.p>

                <div className={styles.cards}>
                    {analyticsPoints.map((item, i) => (
                        <motion.div
                            key={i}
                            className={styles.card}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.2, duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <div className={styles.icon}>{item.icon}</div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbAnalytics
